import { render, staticRenderFns } from "./permissao.vue?vue&type=template&id=3ae39940&scoped=true"
import script from "./permissao.vue?vue&type=script&lang=ts"
export * from "./permissao.vue?vue&type=script&lang=ts"
import style0 from "./permissao.vue?vue&type=style&index=0&id=3ae39940&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae39940",
  null
  
)

export default component.exports